<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols=" 12" class="mb-2">
        <QTextField v-model="editItem.OrganisationNumber"
          :label="$t('servicesystem.common_objects.partner_company.organisation_number')" :rules="[requiredRule]"
          :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
      <v-col cols="12" class="mb-2">
        <QTextField v-model="editItem.CompanyName" :label="$t('servicesystem.common_objects.partner_company.name')"
          :rules="[requiredRule]" :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
      <v-col cols="12" class="mb-2">
        <QTextField v-model="editItem.InvoiceEmailAddress"
          :label="$t('servicesystem.common_objects.partner_company.invoice_email')" :rules="[requiredRule]" clearable
          :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
    <v-row>

    </v-row>
    <v-row>

    </v-row>
    <v-row>
      <v-col>
        <h3>Warehouse</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <WarehouseSelect v-model="editItem.LookupPartsFromWarehouseId" clearable :externaledit="editMode"
          @FocusState="handleFocus">
        </WarehouseSelect>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <QCheckboxInput v-if="editItem.LookupPartsFromWarehouseId" v-model="editItem.UsePartsFromWarehouse"
          :label="'Spend stock'" :externaledit="editMode" @FocusState="handleFocus" :hideInput="true">
        </QCheckboxInput>
      </v-col>
    </v-row>
    <!-- 
    <v-row>
      <v-col cols="12">
        <QCheckboxInput v-model="editItem.ShowArticlePriceToPartner"
          :disabled="editItem.LookupPartsFromWarehouseId == null || (editItem.LookupPartsFromWarehouseId != null && editItem.LookupPartsFromWarehouseId.length == 0)"
          :label="'Show article price to partner'" class="mt-0" @FocusState="handleFocus">
        </QCheckboxInput>
      </v-col>
    </v-row>
    -->
  </v-container>
</template>

<script>
import WarehouseSelect from "@/components/Inputs/EntityDropdowns/WarehouseSelect2.vue";

export default {
  name: "PartnerCompanyEditContent",
  props: {
    editItem: Object,
    editMode: Boolean,
    handleFocus: {
      type: Function,
      default: () => { },
    },
  },
  components: {
    WarehouseSelect
  },

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>